export default "__VITE_ASSET__DVA5B_OD__"